import React, { Component } from 'react';
import { DealershipChooser } from 'components';
import { observe } from 'mobx';
import { AppStore, ShopStore } from 'stores';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class UFPBIReport extends Component {
  state = {};

  componentDidMount() {
    AppStore.setSelectedSidebarKey('/reports');
  }

  disposer = observe(ShopStore.currentShop, 'id', async () => {});

  render() {
    return (
      <div>
        <Row style={{ marginBottom: 10 }}>
          <Col span={24}>
            <DealershipChooser />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col span={24}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {/* <iframe
                title="Fleet Analytics Report - 1"
                style={{ border: '1px solid #ffffff' }}
                width="1575"
                height="643"
                src="https://embed.figma.com/proto/FmiNhBUiy32L1oONLeg5hm/Fleet-Analytics---General-Reports---1AJD?page-id=0%3A1&node-id=315-93&viewport=-2162%2C1309%2C0.32&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=305%3A85&embed-host=share&hide-ui=1"
                allowFullScreen
              /> */}
              <iframe
                title="Worker Order Summary"
                width="1575"
                height="643"
                src="https://app.powerbi.com/reportEmbed?reportId=37f90ee7-e740-4444-a10f-92422747b938&appId=96133079-5ea9-442e-a942-64c29f373b92&autoAuth=true&ctid=d2ac4409-a45c-4ce6-b4f2-668b4e831a05&actionBarEnabled=true"
                frameBorder="0"
                allowFullScreen="true"
              ></iframe>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

UFPBIReport.propTypes = {
  history: PropTypes.object,
};

export default withRouter(UFPBIReport);
